<template>
  <div ref="textbox"
       contenteditable="true"
       v-on="$listeners"
       @input="$emit('update:content', $event.target.innerText)">
  </div>
</template>

<script>
export default {
  name: 'editable',

  props: [
    'content'
  ],

  mounted: function () {
    this.$el.innerText = this.content
  },

  watch: {
    content: function () {
      if (this.$el.innerText !== this.content) {
        this.$el.innerText = this.content
      }
    }
  },

  methods: {
    getSelectionPositions: function () {
      let selection = window.getSelection()
      if (selection.anchorNode != selection.focusNode) {
        return [0, 0]
      }
      return [selection.anchorOffset, selection.focusOffset]
    },

    length: function () {
      return this.$refs.textbox.textContent.length
    },

    setSelection: function(startPos, endPos) {
      if (this.$refs.textbox.firstChild == null) {
        // There's no text in the div, so just put the caret at the beginning.
        window.getSelection().selectAllChildren(this.$refs.textbox)
        window.getSelection().collapseToStart()
        return
      }
      let range = document.createRange()
      let textNode = this.$refs.textbox.firstChild
      range.setStart(textNode, startPos)
      range.setEnd(textNode, endPos)
      let selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
    },

    focusAndCaretAtStart: function () {
      this.$refs.textbox.focus()
      this.setSelection(0, 0)
    },

    focusAndCaretAtEnd: function () {
      this.$refs.textbox.focus()
      let endPos = 0
      if (this.$refs.textbox.firstChild != null) {
        endPos = this.$refs.textbox.firstChild.length
      }
      this.setSelection(endPos, endPos)
    },

    focusAndSetSelection: function (startPos, endPos) {
      this.$refs.textbox.focus()
      this.setSelection(startPos, endPos)
    }
  }
}
</script>
